import React from 'react';
import comms from '../comms';
import FinancialList from './FinancialList';

function Payments({ userSettings }) {
  return (
    <FinancialList
      userSettings={userSettings}
      fetcher={comms.getDriverPayments}
      emptyLabel="No payments found."
    />
  );
}

export default Payments;
